import { render, staticRenderFns } from "./addChainSupplierCatalog.vue?vue&type=template&id=0f8d6889&scoped=true"
import script from "./addChainSupplierCatalog.vue?vue&type=script&lang=js"
export * from "./addChainSupplierCatalog.vue?vue&type=script&lang=js"
import style0 from "./addChainSupplierCatalog.vue?vue&type=style&index=0&id=0f8d6889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d6889",
  null
  
)

export default component.exports